// extracted by mini-css-extract-plugin
export default {"SceneLoaderDisplay":"SceneLoader_SceneLoaderDisplay__jRC7x"};